<script>
    export let viewOptions = {};
    export let trainerData = {};
</script>

<div class="text-zone">
    <div class="color-bar" />
    <h2 class="heading-secondary heading-secondary--darker">
        Jesteś zalogowany jako: {trainerData.email}
    </h2>
    <h3 class="heading-tertiary">Twoje gry:</h3>
    <label for="closed">
        <span class="label label--closed">Pokaz zakończone gry</span>
        <input
            type="checkbox"
            id="closed"
            name="closed"
            bind:checked={viewOptions.showClosed}
        />
        <span class="game__checkbox game__checkbox--closed" />
    </label>
    <label for="running">
        <span class="label label--running">Pokaż trwające gry</span>
        <input
            type="checkbox"
            id="running"
            name="running"
            bind:checked={viewOptions.showRunning}
        />
        <span class="game__checkbox game__checkbox--running" />
    </label>
    <label for="other">
        <span class="label label--other">Pokaż przygotowane gry</span>

        <input
            type="checkbox"
            id="other"
            name="other"
            bind:checked={viewOptions.showOther}
        />
        <span class="game__checkbox game__checkbox--other" />
    </label>
    <h3 class="heading-tertiary">
        Pozostało licencji: {trainerData.playsLeft}
    </h3>
</div>
